import * as ko from "knockout";
import "./../../bindings/bao-toggle-buttons";
function YesNoTag(tagViewModel) {
    var self = this;
    self.Parent = tagViewModel;
    self.init = function () { };
}
export default YesNoTag;